import { render, staticRenderFns } from "./merchantLogin.vue?vue&type=template&id=61c7970f&scoped=true"
import script from "./merchantLogin.vue?vue&type=script&lang=js"
export * from "./merchantLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c7970f",
  null
  
)

export default component.exports